import {
  getAssignablePermissions,
  PERMISSION_PANEL_ORDER,
} from "@/features/permissions/constants/role-permission-catalog";

/** Permissions shown in role/user panels — always from the local catalog (not stale API data). */
export function getRolePermissionsForPanel(role: string): string[] {
  if (!role || role === "SUPER_ADMIN") return [];

  const assignable = new Set(getAssignablePermissions(role));
  return PERMISSION_PANEL_ORDER.filter((permission) => assignable.has(permission));
}
